import { optiMutation } from './base';

export const useGerarAnaliseSeo = () => {
  return optiMutation('/analise-seo/textual', 'post', null);
};

export const useGerarAnaliseSeoNaoTextual = () => {
  return optiMutation('/analise-seo/nao-textual', 'post', null);
};

export const useGerarAnaliseSeoIa = () => {
  return optiMutation('/analise-seo/textual-ia', 'post', null);
};
